import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Toolbar, Tabs, Tab, Typography, Box, Grid } from "@mui/material";
import "../styles/TitleStyle.css"; // ✅：一番トップのタイトル表示
import NoAccountsRoundedIcon from '@mui/icons-material/NoAccountsRounded';
import StoppedCustomersData from "../component/Stopped_customers";
import { ThemeProvider } from '@mui/material/styles';
import theme from '../theme';
 

const  StoppedCustomersPage = () => {

  
  const { isAuthenticated } = useAuth0();
  const [value, setValue] = useState(0); // 初期タブを設定
  

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {isAuthenticated ? (
        <ThemeProvider theme={theme}>
        <Box
          sx={{
            flexGrow: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            padding: 2            
          }}
        >
          {/* AppBarの高さ分を自動調整 */}
          <Toolbar />

          {/* ✅ ヘッダー */}
          <div>
            <div color="default">
              <Toolbar>
                <NoAccountsRoundedIcon  sx={{ color: '#ff8579', mr: 1 }} />
                <Typography variant="h5">取引停止顧客</Typography>
              </Toolbar>
            </div>
          </div>

          {/* ✅ タブメニュー */}
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: 1,
              borderColor: "#C5E763",

              // ✅ すべてのTab（未選択）
              "& .MuiTab-root": {
                color: "#bdc1c7",          // ← クリック前の文字色
                fontWeight: 500,
                textTransform: "none",
              },

              // ✅ 選択中のTab
              "& .MuiTab-root.Mui-selected": {
                color: "#C5E763",          // ← クリック後の文字色
                fontWeight: 700,
              },
            }}
          >
            <Tab label="取引停止顧客一覧" />

            </Tabs>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12 }}>
              {value === 0 && <StoppedCustomersData />}

              
            </Grid>
          </Grid>
        </Box>
        </ThemeProvider>
      ) : (
        <></>
      )}
    </>
  );
  
};

export default StoppedCustomersPage;
